/** @format */
import { ValidatablePlan } from 'common-typescript';
import {
    CreditRange,
    CustomModuleAttainment,
    DegreeProgramme,
    DPSMBase,
    EntityWithRule,
    Module,
    StudyModule,
    Urn,
} from 'common-typescript/types';

export function isStudyModule(module: Module): module is StudyModule {
    return module.type === 'StudyModule';
}

export function isDegreeProgramme(module: Module): module is DegreeProgramme {
    return module.type === 'DegreeProgramme';
}

export function isModule(value: EntityWithRule | CustomModuleAttainment): value is Module {
    return value.type !== 'CustomModuleAttainment' && value.type !== 'Education';
}

export function getTargetCredits(module: Module): CreditRange {
    if (isStudyModule(module) || isDegreeProgramme(module)) {
        return module.targetCredits;
    }
    return null;
}

export function getStudyLevel(module: Module): Urn {
    if (isStudyModule(module)) {
        return module.studyLevel;
    }
    return null;
}

export function getParents(module: Module, validatablePlan: ValidatablePlan): DPSMBase[] {
    const parents: DPSMBase[] = [];
    let currentParent: EntityWithRule = module;
    let parentAdded: boolean;
    do {
        const parentFound: EntityWithRule | CustomModuleAttainment =
            validatablePlan.getParentModuleOrCustomModuleAttainmentForModule(currentParent);
        parentAdded = false;
        if (parentFound && isModule(parentFound) && (isStudyModule(parentFound) || isDegreeProgramme(parentFound))) {
            parents.unshift(parentFound);
            parentAdded = true;
            currentParent = parentFound;
        }
    } while (parentAdded);
    return parents;
}
